import {useState} from "react";
import {withTranslation} from "react-i18next";
import {LeftOutlined, InfoCircleOutlined} from '@ant-design/icons';
import "./ceiba.scss";
import {Button, Tooltip} from 'antd';
import {history} from '_helpers/history'
import localOrSessionStore from "_helpers/localOrSessionStore";
import variables from "_constants/variables";
import Headerbutton from "../component/headerButton";
import {useLocation} from "react-router-dom";

function CeibaInstructions(props) {
    const location = useLocation();
    const [restartQuestions, setRestartQuestions] =  useState(new URLSearchParams(location.search).get('restart') === 'true');

    const storage = localOrSessionStore({ key: variables.REMEMBER });
    const user = JSON.parse(storage.getItem(variables.USER));
    const {t, i18n} =props;

    const saveAndContinue = () => {
        history.push("/admin/assessment")
    }

    const copyCeiba = () => <p className={"tooltip-text"} dangerouslySetInnerHTML={{__html: t('ceiba.copyceiba')}}></p>

    return (
        <>
            <div className={"containerStartCeibaTwo wrapper"}>
                <div className={"insideCeiba boxed"}>
                    <Headerbutton  saveAndContinue={saveAndContinue}  />
                </div>
                <div className={"container-pre-question boxed"}>
                    <div className={"content-pre-question"}>
                        <div className={"content-text-scroll"}>
                            <p className={"pre-question-title"}>
                                {user.name ?? "" },&nbsp;{t("ceiba.init1")}&nbsp;
                                <br/>
                                {t("ceiba.init2")}&nbsp;
                                <Tooltip
                                    overlayStyle={{maxWidth: 500}}
                                    title={copyCeiba}
                                >
                                    <InfoCircleOutlined />
                                </Tooltip>
                            </p>
                            <p className={"pre-question-subtitle"}>{t("ceiba.init3")}</p>
                            <p className={"pre-question-list"} dangerouslySetInnerHTML={{__html: t('ceiba.init4')}} />
                            <p className={"pre-question-list"} dangerouslySetInnerHTML={{__html: t('ceiba.init5')}} />
                            <p className={"pre-question-list"} dangerouslySetInnerHTML={{__html: t('ceiba.init6')}} />
                            <p className={"pre-question-list"} dangerouslySetInnerHTML={{__html: t('ceiba.init7').replace("#nombre#", user.name)}} />
                            <p className={"pre-question-list"} dangerouslySetInnerHTML={{__html: t('ceiba.init8')}} />
                        </div>
                        <Button type={"primary"}
                                onClick={() => history.push(restartQuestions ? "/admin/start-ceiba?restart=true" : "/admin/start-ceiba")}
                                className="primaryButton btn-start">{t("ceiba.startq")}</Button>
                    </div>
                    <Button type="link"
                            icon={<LeftOutlined />}
                            onClick={() => history.push("/admin/ceiba")}
                            className={"btn-back"}

                    >
                        {t("atras")}
                    </Button>
                </div>
                <div className={"footerCeiba"}>
                    <p dangerouslySetInnerHTML={{__html: t('ceiba.copyceiba')}} />
                </div>

            </div>
        </>

    )
}

export default withTranslation()(CeibaInstructions);
